import { selection } from "../../editions/selection/Selection";

export class RowCurve {

    constructor(row, value) {
        this.row = row;
        this.setValue(value);
    }

    setValue(value) {
        if (this.value === value) return;
        this.value = value;

        this.update();
    }

    update() {
        const count = this.row.graphicItems.length;

        const setCurve = (graphicItem, y) => {
            graphicItem.y = y * (-this.value) * 2;
        };

        let index = 0;
        for (let angle = 0; angle <= 180; angle += 180 / (count - 1)) {
            let sinus = Math.sin(angle * Math.PI / 180.0);
            let y = Math.round(sinus * 100) / 100;
            setCurve(this.row.graphicItems[index++], y);
        }

        if (this.row.sequence) this.row.sequence.updateLabelsPosition();
        if (this.row.label) this.row.label.update();
        selection.update();
    }
}